import { render } from "./ResetVerify.vue?vue&type=template&id=19803fd8&scoped=true"
import script from "./ResetVerify.vue?vue&type=script&lang=js"
export * from "./ResetVerify.vue?vue&type=script&lang=js"

import "./ResetVerify.vue?vue&type=style&index=0&id=19803fd8&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19803fd8"]])

export default __exports__